
      import { isPengyang, isShuxiangyuan } from '/src/utils/brandHost.js'

      const host = window.location.host
      if (document.documentElement.clientWidth <= 768 && !isPengyang(host)) {
        location.replace(`${location.origin}/m/index.html`)
      }
      if (isPengyang(host)) {
        document.querySelector('#ico').href = '/imgs/pengyangIco.png'
        document.title = '朋阳教育-教务管理系统-培训学校管理系统'
      }
      if (isShuxiangyuan(host)) {
        document.querySelector('#ico').href = '/imgs/shuxiangyuanIco.png'
        document.title = '书香源-教务管理系统-培训学校管理系统'
      }
    